export enum QUERY_KEYS {
  COMMENTS = 'COMMENTS',
}

export default QUERY_KEYS
